import React, { Component, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Translate from "../../components/Shared/Translate.js";
import axios from "axios";
import { variables } from '../../components/Shared/Variables.js';
import { useDispatch, useSelector } from "react-redux";
import {
  updateChild,
  updateParent,
  updategrandChild,
  updateggChild,
  updateExtended,
} from "../../features/breadcrumb/breadcrumbSlice";
import {
  callingNextPrev, updateFilterRetained, updateNodeIdForAssGetData, updateIsBlockCourseIndexAPi, updateNextPrevUpdated, callingDispose
} from "../../features/CourseIndex/courseIndexSlice";

const NavigationBtnsRgsa = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nodeValue = useSelector(state => state.courseindex.nodeData);
  const nodeValFromLocalStorage = JSON.parse(localStorage.getItem("nodeVal") || "[]");
  // // console.log("nodeValFromLocalStorage : ",nodeValFromLocalStorage);
  const currenNodeIdAt = useSelector(state => state.courseindex.currenNodeIdAt);
  const isNextPrevUpdated = useSelector(state => state.courseindex.isNextPrevUpdated);
  const callingGetTopicsList = useSelector(state => state.courseindex.callingGetTopicsList);
  const userId = sessionStorage.getItem("login-userId");
  const courseData = JSON.parse(sessionStorage.getItem("coursedata"));
  const meetingData = sessionStorage.getItem("meeting");
  // const guidedLearningStatus = sessionStorage.getItem("guidedLearningStatus");
  // // console.log("meetingData : ", JSON.parse(meetingData));
  const topicDetails = sessionStorage.getItem("topicDetails");
  const [toggle, setToggle] = useState(false);
  // // console.log("props in navigation btns : ", props);
  var temp = props.topicsListData.findIndex(topics => topics.topicStatus == "Open")
  // // console.log("temp value : ", temp);
  // var indexNoInNavBtns = temp == -1 ? props.index : temp

  var indexNoInNavBtns = props.index;
  // console.log("props in NavigationBtns :", props);
  let dataOfProps = props.topicsListData?.length > 0 ? props.topicsListData : JSON.parse(meetingData);
  // // console.log("dataOfProps in NavigationBtns : ", dataOfProps);
  let resAfterFetchingNextPrevfuncCalling = JSON.parse(sessionStorage.getItem("nextPrevData"));

  // // console.log("currenNodeIdAt : ", currenNodeIdAt);

  const [isPrev, setIsPrev] = useState();
  const [isNext, setIsNext] = useState();
  const [isCurrent, setIsCurrent] = useState();
  const [allTopics, setAllTopics] = useState([]);

  const nextPrevDataFunc = async () => {

    let resAfterFetchingNextPrev = JSON.parse(sessionStorage.getItem("nextPrevData"));
    // console.log("resAfterFetchingNextPrev : ", resAfterFetchingNextPrev);
    if (resAfterFetchingNextPrev?.data.isSuccess) {
      // // console.log("indexNoInNavBtns : ", indexNoInNavBtns);
      // // console.log("resAfterFetchingNextPrev.data.userDataList : ", resAfterFetchingNextPrev.data.userDataList);
      // // console.log("final dataOfProps : ", dataOfProps[0].nodeId);
      // debugger
      for (let i = 0; i < resAfterFetchingNextPrev?.data.userDataList.length; i++) {
        if (props.topicsListData?.length > 0) {
          // console.log("indexNoInNavBtns : ", indexNoInNavBtns);
          if (indexNoInNavBtns < 1) {
            // // console.log(`inin  value if i = ${i}: ,${resAfterFetchingNextPrev.data.userDataList[i].nodeID}, ${dataOfProps[0].nodeID}`)
            if (resAfterFetchingNextPrev.data.userDataList[i].nodeID == dataOfProps[0].nodeID) {
              // // console.log("value of i : ",i);
              if (i > 0 && i < resAfterFetchingNextPrev.data.userDataList.length - 1) {
                // // console.log("setting both next prev : ", i);
                setIsNext(resAfterFetchingNextPrev.data.userDataList[i + 1]);
                setIsPrev(resAfterFetchingNextPrev.data.userDataList[i - 1]);
                setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
              } else if (i == 0) {
                // // console.log("setting next only : ", i);
                setIsNext(resAfterFetchingNextPrev.data.userDataList[i + 1]);
                setIsPrev();
                setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
              } else if (i == resAfterFetchingNextPrev.data.userDataList.length - 1) {
                // // console.log("setting prev only : ", i);
                setIsPrev(resAfterFetchingNextPrev.data.userDataList[i - 1]);
                setIsNext();
                setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
              }
            }
          } else {
            // // console.log("value of i in setting is next if last obj : ",i,indexNoInNavBtns);
            if (indexNoInNavBtns == props.topicsListData.length - 1) {
              // // console.log("resAfterFetchingNextPrev.data.userDataList[i].nodeID : ",resAfterFetchingNextPrev.data.userDataList[i].nodeID);
              // // console.log("props.topicsListData[indexNoInNavBtns].nodeID : ",props.topicsListData[indexNoInNavBtns].nodeID)
              if (resAfterFetchingNextPrev.data.userDataList[i].nodeID == props.topicsListData[indexNoInNavBtns].nodeID) {
                // // console.log("inside resAfterFetchingNextPrev.data.userDataList[i].nodeID == props.topicsListData[indexNoInNavBtns] : ",i,indexNoInNavBtns)
                setIsNext(resAfterFetchingNextPrev.data.userDataList[i + 1]);
                setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i]);
                setIsPrev(props.topicsListData[indexNoInNavBtns - 1]);
              }
            } else {
              for (let j = 0; j < resAfterFetchingNextPrev.data.userDataList.length; j++) {
                if (resAfterFetchingNextPrev?.data?.userDataList[j].nodeID == props.topicsListData[indexNoInNavBtns].nodeID) {
                  setIsNext(resAfterFetchingNextPrev.data.userDataList[j + 1]);
                  setIsCurrent(resAfterFetchingNextPrev.data.userDataList[j]);
                }
              }
              setIsPrev(props.topicsListData[indexNoInNavBtns - 1]);
            }
          }
        } else {
          // // console.log('yooooooooononon : ', resAfterFetchingNextPrev.data.userDataList[i].sessionID, dataOfProps[0])

          if (resAfterFetchingNextPrev.data.userDataList[i].sessionID == dataOfProps[0].sessionID) {
            if (i > 0 && i < resAfterFetchingNextPrev.data.userDataList.length - 1) {
              // // console.log("setting both next prev");
              setIsNext(resAfterFetchingNextPrev.data.userDataList[i + 1]);
              setIsPrev(resAfterFetchingNextPrev.data.userDataList[i - 1]);
              setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
            } else if (i == 0) {
              // // console.log("setting next only");
              setIsNext(resAfterFetchingNextPrev.data.userDataList[i + 1]);
              setIsPrev();
              setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
            } else if (i == resAfterFetchingNextPrev.data.userDataList.length - 1) {
              // // console.log("setting prev only")
              setIsPrev(resAfterFetchingNextPrev.data.userDataList[i - 1]);
              setIsNext();
              setIsCurrent(resAfterFetchingNextPrev.data.userDataList[i])
            }
          }
        }

      }
      setAllTopics(resAfterFetchingNextPrev.data.userDataList);
    } else {
      // // console.log("error or something went wrong in resAfterFetchingNextPrev");
    }
  }

  useEffect(() => {
    if (isNextPrevUpdated) {
      dispatch(updateNextPrevUpdated(false));
      // // console.log("seeting toggle for updating ui");
      setToggle(!toggle);
    }
    // // console.log("calling nextPrevDataFunc")
    nextPrevDataFunc();

    // nextPrevData();
  }, [dataOfProps, indexNoInNavBtns, props.index, isNextPrevUpdated])

  const goBackToIndexPage = async () => {
    if (props.setIsBackBtnClicked) {
      dispatch(callingDispose(true));
      await props.setIsBackBtnClicked(true);
    }
    dispatch(updateFilterRetained(true));
    dispatch(updateNextPrevUpdated(true));
    navigate(`../CourseIndex`);
  }

  const callingForNextOrPrev = async (subnode, from, currentNode) => {
    if (props.setIsBackBtnClicked) {
      await props.setIsBackBtnClicked(true);
    }
    // // console.log("subnode : " + JSON.stringify(subnode))
    sessionStorage.setItem("subNodeData", JSON.stringify(subnode))
    let arr = [];
    // // console.log("updateContentBreadCrumb called : ", subnode);
    arr.push(subnode);
    // console.log("arr in session in navigations btns : ", arr);
    sessionStorage.setItem("meeting", JSON.stringify(arr));
    dispatch(updateChild("Content"));
    // dispatch(updategrandChild(subnode.nodeName));
    if (subnode.sessionDeliveryMode === 1) {
      if (from == "next") {
        if (subnode.topicStatus == "Completed") {
          // console.log("link to complete")
          navigate(`/VirtualSession/2`);
        } else {
          // console.log("normal vc link")
          navigate(`/VirtualSession/${isNext.sessionID}`);
        }
      } else if (from == "prev") {
        if (subnode.topicStatus == "Completed") {
          // console.log("link to complete")
          navigate(`/VirtualSession/2`);
        } else {
          // console.log("normal vc link")
          navigate(`/VirtualSession/${isNext.sessionID}`);
        }
      }
    } else if (subnode.sessionDeliveryMode === 2) {
      // // console.log("")
      dispatch(callingNextPrev(true));
      if (from == "next") {
        // alert("navigating 191")
        navigate(`/TopicDetailsRgsa/${subnode.sessionName}/${subnode.sessionID}/8574/${subnode.sessionDeliveryMode}/Theory`);
      } else {
        navigate(`/TopicDetailsRgsa/${subnode.sessionName}/${subnode.sessionID}/8574/${subnode.sessionDeliveryMode}/Theory`);
      }
    } else if (subnode.sessionDeliveryMode === 4) {
      // // console.log("isNext Val : ", subnode);
      dispatch(callingNextPrev(true));
      if (from == "next") {
        dispatch(updateNodeIdForAssGetData(isNext.nodeID));
        navigate(`/TopicDetailsRgsa/${subnode.sessionName}/${subnode.sessionID}/8574/${subnode.sessionDeliveryMode}/${subnode.sessionExamMode}`);
      } else {
        dispatch(updateNodeIdForAssGetData(isPrev.nodeID));
        navigate(`/TopicDetailsRgsa/${subnode.sessionName}/${subnode.sessionID}/8574/${subnode.sessionDeliveryMode}/${subnode.sessionExamMode}`);
      }
    }
  }

  const updateContentBreadCrumb = async (subnode, from, currentNode) => {
    // console.log("props.topicsListData in updateContentBreadCrumb value : ", props.topicsListData.length);
    // console.log("topicDetails in naviagtion btns from session : ", JSON.parse(topicDetails).nodeID);
    dispatch(updateNextPrevUpdated(true));
    await dispatch(callingDispose(true));
    props.setIsindexChanged(-1);
    if (props.topicsListData.length > 1) {
      let ind = 0;
      for (let k = 0; k < props.topicsListData.length; k++) {
        if (props.topicsListData[k].nodeID == JSON.parse(topicDetails).nodeID) {
          if (from == "next") {
            ind = k + 1
          } else {
            ind = k - 1
          }
        }
      }
      // // console.log("final val of ind : ", ind);
      // props.setIndex(ind);
      if (ind <= props.topicsListData.length - 1 && ind >= 0) {
        // // console.log("check for handle topic list function");
        handleTopicClickInNavigationBtns(props.topicsListData[ind].nodeID, ind, props.topicsListData[ind].sessionName, props.topicsListData[ind].nodeName, props.topicsListData[ind])
        // props.setIndex(ind);
        // // console.log("props.topicsListData.length - 1 : ",props.topicsListData.length - 1)
        if (ind == props.topicsListData.length - 1) {
          if (from == "next") {
            let tempIsNextInd = 0;
            for (let d = 0; d < allTopics.length; d++) {
              if (allTopics[d].nodeID == props.topicsListData[ind].nodeID) {
                tempIsNextInd = d + 1
              }
            }
            // console.log("seting isNext : ", allTopics[tempIsNextInd]);
            setIsNext(allTopics[tempIsNextInd]);
            setIsCurrent(allTopics[tempIsNextInd - 1])
            props.setCurrentTopicContentData(allTopics[tempIsNextInd - 1])
            setIsPrev();
          }
        } else {
          // console.log("set isNext to normal");
          setIsNext(props.topicsListData[ind + 1]);
          setIsCurrent(props.topicsListData[ind]);
          props.setCurrentTopicContentData(props.topicsListData[ind]);
          setIsPrev(props.topicsListData[ind - 1]);
        }

      } else {
        // console.log("go for the next topic : ", allTopics);
        props.setIndex(0);
        let filterInd = 0;
        for (let a = 0; a < allTopics.length; a++) {
          if (allTopics[a].nodeID == JSON.parse(topicDetails).nodeID) {
            // // console.log("calling fiteredInd at : ", filterInd);
            if (from == "next") {
              // console.log("is next : ", allTopics[a + 1]);
              setIsNext(allTopics[a + 1]);
              setIsCurrent(allTopics[a]);
              props.setCurrentTopicContentData(allTopics[a]);
              callingForNextOrPrev(allTopics[a + 1], from, currentNode);
            } else {
              setIsPrev(allTopics[a - 1])
              callingForNextOrPrev(allTopics[a - 1], from, currentNode);
            }
            filterInd = a
          }
          // if(from == "next"){
          //   let filteredVal = allTopics.filter((it)=>{
          //     return it.nodeID == JSON.parse(topicDetails).nodeID
          //   })
          //   // console.log("goto next from next in filtered : ",filteredVal)
          // } else {
          //   let filteredVal = allTopics.filter((it)=>{
          //     return it.nodeID == JSON.parse(topicDetails).nodeID
          //   })
          //   // console.log("goto next from prev in filtered : ",filteredVal)
          // }
        }

      }
    } else {
      callingForNextOrPrev(subnode, from, currentNode);
    };
  }

  const handleNextPrev = (from) => {
    // console.log("handleNextPrev from : ", from);
    if (from == "next") {
      // SessionRedirectionLink(isNext.sessionDeliveryMode,isNext.nodeName,isNext.nodeID,courseData.batchId,"Theory",isNext.topicStatus)
      if (isNext.sessionDeliveryMode == 2) {
        // console.log("navigating to topic details")
        navigate(`/TopicDetailsRgsa/${isNext.nodeName}/${isNext.nodeID}/${courseData.batchId}/${isNext.sessionDeliveryMode}/Theory`);
      }
    } else {

    }
  }

  const handleTopicClickInNavigationBtns = (nodeID, ind, vcTitleHeading, topicName, topics) => {
    // console.log(`inside topiclist handleTopicClick : ${nodeID} ;;;`)
    if (nodeID === "m") {
      props.setIndex("m")
      dispatch(updateggChild("Meeting Details"))
      props.onTopicClick(nodeID)
      props.sessionType === "meeting" && props.setVcTitleHeading("Meeting Details");
    } else {
      props.setIndex(ind)
      sessionStorage.setItem("topicDetails", JSON.stringify(topics))
      dispatch(updateggChild(topicName))
      props.sessionType === "meeting" && props.setVcTitleHeading(vcTitleHeading);
      var listData = props.topicsListData;
      var data = listData.filter((topics) => topics.nodeID == nodeID);
      if ((data[0].topicStatus != "Locked") && (data[0].sessionDeliveryMode == 2 || data[0].sessionDeliveryMode == 1)) {
        props.onTopicClick(data, true);
      }
    }

    if (props.isTopicChanged) {
      props.setIsTopicChanged(!props.isTopicChanged)
    }
  }

  const isCheckIsNextSessionStarts = (isCheck) => {
    // console.log("isCheck in func : ", isCheck);
    if (isCheck.topicStatus == "Locked") {
      return false
    } else {
      return false;
    }
  }

  const isDisabledNext = () => {
    if (isNext?.topicStatus === "Locked") {
      return true
    } else {
      if (isNext?.topicStatus === "Open") {
        if (isCurrent?.sessionID == isNext?.sessionID) {
          if (isCurrent.topicStatus == "Completed") {
            const endDate = new Date(isNext?.sessionReleaseDate);
            // Get the current date and time
            const currentDate = new Date();
            // Compare the two dates
            if (endDate > currentDate) {
              // console.log("The session release date is in the future.");
              return true
            } else {
              // console.log("The session release date is right now!");
              return false
            }
          } else {
            return true
          }
        } else {
          const endDate = new Date(isNext?.sessionReleaseDate);
          // Get the current date and time
          const currentDate = new Date();
          // Compare the two dates
          if (endDate > currentDate) {
            // console.log("The session release date is in the future.");
            return true
          } else {
            // console.log("The session release date is right now!");
            return false
          }
        }
      } else {
        return false
      }
    }
  };
  const isDisabledPrev = () => {
    if (isPrev?.topicStatus === "Locked") {
      return true
    } else {
      if (isPrev?.topicStatus === "Open") {
        const endDate = new Date(isPrev?.sessionReleaseDate);
        // Get the current date and time
        const currentDate = new Date();
        // Compare the two dates
        if (endDate > currentDate) {
          // console.log("The session release date is in the future.");
          return true
        } else {
          // console.log("The session release date is right now!");
          return false
        }
      } else {
        return false
      }
    }
  };



  // console.log("isNext : ", isNext);
  // // console.log("isPrev : ", isPrev);
  // console.log("isCurrent : ", isCurrent);

  return (
    <>
      <div class="col-md-12 d-flex actionbtns-rgsa p-3">
        <div className={isPrev ? "" : "invisible"}>
          <button onClick={() => updateContentBreadCrumb(isPrev, "prev", isCurrent)} disabled="" class=""><img src="../../Assets/Linqskills_icons/back-btn-rgsa.svg" class=" me-1"></img><Translate textKey="topic001" /></button>
        </div>
        <div class={isNext ? "" : "invisible"}>
          <button onClick={() => updateContentBreadCrumb(isNext, "next", isCurrent)} disabled="" class=""><Translate textKey="topic002" /><img src="../../Assets/Linqskills_icons/arrow-right-rgsa.svg" class="float-end ms-1"></img></button>
        </div>
      </div>
    </>
  )
}

export default NavigationBtnsRgsa